<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="rfq-create-form full-width-container1" style="display: flex; flex-direction: column;overflow-x: hidden;">
      <div class="rfq-create-form-title">

          <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
              <div id="createquotation">
                <!-- Create Purchase Order -->
              </div>
              <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close()">Close<mat-icon>navigate_next</mat-icon></button>
          </div>
      </div>

      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">
          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content class="ship-fscoll hgt ship-pr-sec">
                  <nav mat-tab-nav-bar class="tagGroup">
                      <a mat-tab-link *ngFor="let tabItem of tabs; let idx = index"
                          [class.active-link]="currentTab === tabItem.route" class="teb_icon"
                          (click)="selectMatTabLink(tabItem)">
                          <span id="navstepstext">{{tabItem.label}}</span>
                      </a>
                  </nav>
                  <!-- <div class="approval-list-container">
                    <div
                        class="approver-card"
                        *ngFor="let approver of approvalList"
                    >
                        <div class="approver-header">
                        <div>
                            <h4 style="font-weight: bold;">{{ approver.role }}</h4>
                            <p class="approver-name">{{ approver.approverName }}</p>
                            <small class="approver-department">
                            {{ approver.department }} – {{ approver.roleDescription }}
                            </small>
                            <br />
                            <small *ngIf="approver.approvalCreatedAt">
                            {{ approver.approvalCreatedAt | date: 'MMM d, y' }}
                            </small>
                            <p *ngIf="approver.approverComments">{{ approver.approverComments }}</p>
                        </div>

                        <span
                            class="status-badge"
                            [ngClass]="{
                            'approved': approver.approverStatus === 'APPROVED',
                            'rejected': approver.approverStatus === 'REJECTED',
                            'pending': approver.approverStatus === null
                            }"
                        >
                            {{
                            approver.approverStatus
                                ? approver.approverStatus
                                : 'PENDING'
                            }}
                        </span>
                        </div>

                        
                        <div
                        class="approver-actions"
                        *ngIf="approver.isApprover === 1"
                        >
                        <button mat-stroked-button color="primary" (click)="onApprove(approver)" style="font-weight: bold;">
                            Approve
                        </button>
                        <button mat-stroked-button color="warn" (click)="onReject(approver)" style="font-weight: bold;">
                            Reject
                        </button>
                        <button mat-stroked-button (click)="onAddComment(approver)" style="font-weight: bold;">
                            Add Comment
                        </button>
                        </div>
                    </div>
                  </div> -->

                  <!-- <div class="approval-list-container">
                    <div class="po-reference" *ngIf="approvalList && approvalList.length > 0">
                        <h3 style="font-weight: bold; color: white; background-color: #1f4e79; padding: 15px 12px; border-radius: 6px;margin-top: 20px;">
                            {{ approvalList[0].purchaseOrderRefNumber }}
                        </h3>
                    </div>
                    <div class="approver-card" *ngFor="let approver of approvalList">
                        <div class="approver-header">
                        <div>
                            <h4 style="font-weight: bold;">{{ approver.role }}</h4>
                            <p class="approver-name">{{ approver.approverName }}</p>
                            <small class="approver-department">
                            {{ approver.department }} – {{ approver.roleDescription }}
                            </small>
                            <br />
                            <small *ngIf="approver.approvalCreatedAt">
                            {{ approver.approvalCreatedAt | date: 'MMM d, y' }}
                            </small>
                            <p *ngIf="approver.approverComments">{{ approver.approverComments }}</p>
                        </div>

                        <span
                            class="status-badge"
                            [ngClass]="{
                            approved: approver.approverStatus === 'Approved',
                            rejected: approver.approverStatus === 'Rejected',
                            pending: approver.approverStatus === null
                            }"
                        >
                            {{ approver.approverStatus ? approver.approverStatus : 'PENDING' }}
                        </span>
                        </div>

                       
                        <div class="approver-actions" *ngIf="approver.isApprover === 1 && approver.approverStatus === null">
                        <button
                            mat-stroked-button
                            color="primary"
                            (click)="toggleActionBox(approver, 'approve')"
                            style="font-weight: bold;"
                        >
                            Approve
                        </button>

                        <button
                            mat-stroked-button
                            color="warn"
                            (click)="toggleActionBox(approver, 'reject')"
                            style="font-weight: bold;"
                        >
                            Reject
                        </button>

                        
                        </div>

                       
                        <div
                        *ngIf="approver.showActionBox"
                        class="comment-popup"
                        >
                        <textarea
                            placeholder="Add your comment here..."
                            [(ngModel)]="approver.tempComment"
                            rows="3"
                        ></textarea>

                        <div class="popup-actions">
                            <button
                            *ngIf="approver.actionType === 'approve'"
                            mat-raised-button
                            color="primary"
                            (click)="confirmApprove(approver)"
                            >
                            Sure, Approve
                            </button>

                            <button
                            *ngIf="approver.actionType === 'reject'"
                            mat-raised-button
                            color="warn"
                            (click)="confirmReject(approver)"
                            >
                            Sure, Reject
                            </button>

                            <button mat-stroked-button (click)="cancelAction(approver)">
                            Cancel
                            </button>
                        </div>
                        </div>
                    </div>
                  </div> -->

                  <div class="approval-list-container">
                    <div class="po-reference" *ngIf="approvalList && approvalList.length > 0">
                        <h3 class="po-header">
                        {{ approvalList[0].purchaseOrderRefNumber }}
                        </h3>
                    </div>

                    <div class="approver-grid">
                        <div class="approver-card" *ngFor="let approver of approvalList">
                        <div class="approver-header">
                            <div>
                            <h4 class="approver-name">{{ approver.approverName }}</h4>
                            <h4 class="approver-role">{{ approver.role }}</h4>
                            <small class="approver-department">
                                {{ approver.department }} – {{ approver.roleDescription }}
                            </small>
                            <br />
                            <small *ngIf="approver.approvalCreatedAt">
                                {{ approver.approvalCreatedAt | date: 'MMM d, y' }}
                            </small>
                            <p *ngIf="approver.approverComments">{{ approver.approverComments }}</p>
                            </div>

                            <span
                            class="status-badge"
                            [ngClass]="{
                                approved: approver.approverStatus === 'Approved',
                                rejected: approver.approverStatus === 'Rejected',
                                pending: approver.approverStatus === null
                            }"
                            >
                            {{ approver.approverStatus ? approver.approverStatus : 'PENDING' }}
                            </span>
                        </div>

                        <div
                            class="approver-actions"
                            *ngIf="approver.isApprover === 1 && approver.approverStatus === null && approver.purchaseOrderStatus !== 3"
                        >
                            <button
                            mat-stroked-button
                            color="primary"
                            (click)="toggleActionBox(approver, 'approve')"
                            style="font-weight: bold;"
                            >
                            Approve
                            </button>

                            <button
                            mat-stroked-button
                            color="warn"
                            (click)="toggleActionBox(approver, 'reject')"
                            style="font-weight: bold;"
                            >
                            Reject
                            </button>
                        </div>

                        <div
                            class="approver-actions"
                            *ngIf="approver.isApprover === 1 && approver.approverStatus === 'Approved'"
                            style="justify-content:flex-end"
                        >
                            <!-- <button
                            mat-raised-button
                            color="primary"
                            class="send-po-btn"
                            style="background-color: #1F7E3F;"
                            (click)="sendPO()"
                            >
                            Send PO
                            </button> -->
                            <button
                                mat-raised-button
                                color="primary"
                                class="send-po-btn"
                                style="background-color: #1F7E3F;"
                                (click)="approver.purchaseOrderStatus !== 3 && sendPO()"
                            >
                                {{ approver.purchaseOrderStatus === 3 ? 'PO Sent' : 'Send PO' }}
                            </button>
                        </div>

                        <div *ngIf="approver.showActionBox" class="comment-popup">
                            <textarea
                            placeholder="Add your comment here..."
                            [(ngModel)]="approver.tempComment"
                            rows="3"
                            ></textarea>

                            <div class="popup-actions">
                            <button
                                *ngIf="approver.actionType === 'approve'"
                                mat-raised-button
                                color="primary"
                                (click)="confirmApprove(approver)"
                            >
                                Sure, Approve
                            </button>

                            <button
                                *ngIf="approver.actionType === 'reject'"
                                mat-raised-button
                                color="warn"
                                (click)="confirmReject(approver)"
                            >
                                Sure, Reject
                            </button>

                            <button mat-stroked-button (click)="cancelAction(approver)">
                                Cancel
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                  </div>

              </mat-card-content>
          </mat-card>
      </div>
  </div>
</div>

